import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=b9017ab4&scoped=true&"
import script from "./AccountView.vue?vue&type=script&lang=js&"
export * from "./AccountView.vue?vue&type=script&lang=js&"
import style0 from "./AccountView.vue?vue&type=style&index=0&id=b9017ab4&lang=scss&scoped=true&"
import style1 from "./AccountView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9017ab4",
  null
  
)

export default component.exports